export class ScheduleTestDrivePopupSession {
  static ScheduleTestDriveSessionExists(id) {
    return !!sessionStorage.getItem(window.tid + id);
  }
  static setScheduleTestDriveSession(id) {
    let key = window.tid + id;
    sessionStorage.setItem(key, window.tid);
  }
}
